import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Version from "version";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Slide from '@material-ui/core/Slide';
import Button from "components/CustomButtons/Button";
import ButtonX from '@material-ui/core/Button';
import ReactLoading from 'react-loading';
import Icon from "../components/Selfcare/Common/Icon";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import pink from '@material-ui/core/colors/pink';
import { DatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';
import nbLocale from "date-fns/locale/nb";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle";

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);

const styles = theme => ({
    ...pricingPageStyle,
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(1),
    },
    cssLabel: {
        '&$cssFocused': {
            color: pink[500],
        },
    },
    cssFocused: {},
    cssUnderline: {
        '&:after': {
            borderBottomColor: pink[500],
        },
    },
});

const theme = createMuiTheme({
    palette: {
        primary: pink,
    },
    typography: { useNextVariants: true },
});


class ChangeUserAddress extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("ChangeUserAddress", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            Firstname: '',
            Lastname: '',
            Birthdate: '',
            AddressLine: '',
            PostalCode: '',
            City: '',
            EmailAddress: '',
            ContactPhone: '',
            AcceptPasswordViaEmail: false,
            ExportUserInfo: false,
            OrderSent: false,
            OrderError: '',
            buzy: false,
            ErrorField: '',
            ErrorText: '',
            BlockChangeAddress: false,
        };
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.OrderSent && !this.state.OrderSent) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.changeregistered'),
                html: this.props.t('selfcare:notification.infoupdatedwithinminutes'),
                icon: 'success',
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                this.setState({ redirect: true, toUrl: '/overview' });
            });
        }
        if (nextState.OrderError && !this.state.OrderError) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.changefailed'),
                html: nextState.OrderError,
                icon: 'error',
                confirmButtonColor: '#e91e63',
            });
            this.setState({ buzy: false });
        }
        if (nextState.ErrorField && !this.state.ErrorField) {
            this.setState({ buzy: false });
            this.setFocus(nextState.ErrorField);
        }
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }

    setFocus = fieldName => {
        switch (fieldName) {
            case "Firstname":
                if (this.Firstname) {
                    setTimeout(() => {
                        this.Firstname.focus();
                    }, 10);
                }
                break;
            case "Lastname":
                if (this.Lastname) {
                    setTimeout(() => {
                        this.Lastname.focus();
                    }, 10);
                }
                break;
            case "Birthdate":
                if (this.Birthdate) {
                    setTimeout(() => {
                        this.Birthdate.focus();
                    }, 10);
                }
                break;
            case "EmailAddress":
                if (this.EmailAddress) {
                    setTimeout(() => {
                        this.EmailAddress.focus();
                    }, 10);
                }
                break;
            case "AddressLine":
                if (this.AddressLine) {
                    setTimeout(() => {
                        this.AddressLine.focus();
                    }, 10);
                }
                break;
            case "PostalCode":
                if (this.PostalCode) {
                    setTimeout(() => {
                        this.PostalCode.focus();
                    }, 10);
                }
                break;
        }
    }

    handleDateChange = date => {
        this.setState({ Birthdate: date });
    };

    handleChange = name => event => {
        this.setState({ [name]: event.target.value, ErrorField: '' });
        if (name === 'PostalCode') {
            this.dispatchState({ Lookup: event.target.value });
        }
    }

    handleSave = () => {
        this.dispatchState({ PerformChange: { Firstname: this.state.Firstname, Lastname: this.state.Lastname, Birthdate: this.state.Birthdate, AddressLine: this.state.AddressLine, PostalCode: this.state.PostalCode, EmailAddress: this.state.EmailAddress, IsUserAddressPrimary: this.state.IsUserAddressPrimary, AllowEmailPassword: this.state.AllowEmailPassword } });
        this.setState({ buzy: true, ErrorField: '' });
    }
    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }
    render() {
        console.debug('ChangeUserAddress render');
        const classes = this.props;
        const { t } = this.props;
        const postcodelen = this.state.IsNorway ? 4 : 5;
        const dateformat = this.state.IsNorway ? 'dd.MM.yyyy' : 'yyyy-MM-dd';
        const dateplace = this.state.IsNorway ? 'dd.mm.åååå' : 'åååå-mm-dd';
        return (
            <div style={{ height: '100vh' }}>
                {this.state.redirect ? <Redirect to={this.state.toUrl} /> : null}
                {this.state.IsAdministrating && <div style={{ backgroundColor: 'black', color: 'white', height: '50px', paddingLeft: '5px', textAlign: 'center', borderBottom: '1px grey solid' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.nowadministratingnumber', { 0: this.state.AdministratedMsisdn }) }} /><br /><a style={{ color: 'white' }} href='/overview' onClick={(e) => { sessionStorage.stopAdmin = this.state.LoggedInMsisdn; this.navigateTo('/overview'); e.preventDefault(); }}>{t('selfcare:button.backtologgedinuser')}</a></div>}
                    <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={10} md={8} lg={6} xl={4} >
                                <Icon name="profile" size={48} color="#FFFFFF" />
                                <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                    {t('selfcare:item.updateuserinfo')}
                                    </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                    <div>
                        <GridContainer justify="center">
                            <MuiThemeProvider theme={theme}>
                                <GridItem xs={12} sm={10} md={8} lg={6} xl={4} >
                                    <div style={{ paddingTop: '20px', paddingLeft: '10px', fontWeight: '700' }}>{t('selfcare:title.userinfo')}</div>
                                    <GridContainer>
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'Firstname'}
                                                disabled={this.state.buzy || this.state.BlockChangeAddress}
                                                label={t('selfcare:label.firstname')}
                                                value={this.state.Firstname}
                                                id="Firstname"
                                                onChange={this.handleChange('Firstname')}
                                                className={classes.textField}
                                                inputProps={{ maxLength: 30 }}
                                                helperText={this.state.ErrorField === 'Firstname' && this.state.ErrorText}
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={(el) => { this.Firstname = el; }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'Lastname'}
                                                disabled={this.state.buzy || this.state.BlockChangeAddress}
                                                label={t('selfcare:label.lastname')}
                                                value={this.state.Lastname}
                                                id="Lastname"
                                                onChange={this.handleChange('Lastname')}
                                                className={classes.textField}
                                                inputProps={{ maxLength: 30 }}
                                                helperText={this.state.ErrorField === 'Lastname' && this.state.ErrorText}
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={(el) => { this.Lastname = el; }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={nbLocale}>
                                                <DatePicker error={this.state.ErrorField === 'Birthdate'}
                                                    disabled={this.state.buzy || this.state.BlockChangeAddress}
                                                    fullWidth
                                                    clearable
                                                    clearLabel={t('selfcare:label.simply')}
                                                    label={t('selfcare:label.birthdate')}
                                                    minDate={new Date("1910-01-01")}
                                                    disableFuture
                                                    value={this.state.Birthdate}
                                                    onChange={this.handleDateChange}
                                                    format={dateformat}
                                                    emptyLabel=""
                                                    invalidLabel=""
                                                    placeholder={dateplace}
                                                    invalidDateMessage={t('selfcare:label.invaliddate')}
                                                    minDateMessage={t('selfcare:label.mindate')}
                                                    autoOk
                                                    cancelLabel={t('selfcare:label.cancel')}
                                                    inputRef={(el) => { this.Birthdate = el; }}
                                                    helperText={this.state.ErrorField === 'Birthdate' && this.state.ErrorText}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'AddressLine'}
                                                disabled={this.state.buzy || this.state.BlockChangeAddress}
                                                label={t('selfcare:label.address')}
                                                value={this.state.AddressLine}
                                                onChange={this.handleChange('AddressLine')}
                                                id="AddressLine"
                                                className={classes.textField}
                                                inputProps={{ maxLength: 30 }}
                                                helperText={this.state.ErrorField === 'AddressLine' && this.state.ErrorText}
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={(el) => { this.AddressLine = el; }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'PostalCode'}
                                                disabled={this.state.buzy || this.state.BlockChangeAddress}
                                                label={t('selfcare:label.postalcode')}
                                                value={this.state.PostalCode}
                                                onChange={this.handleChange('PostalCode')}
                                                id="PostalCode"
                                                className={classes.textField}
                                                type='tel'
                                                inputProps={{ maxLength: { postcodelen } }}
                                                helperText={this.state.ErrorField === 'PostalCode' && this.state.ErrorText}
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={(el) => { this.PostalCode = el; }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <TextField fullWidth
                                                disabled
                                                label={t('selfcare:label.postalcity')}
                                                value={this.state.City}
                                                id="City"
                                                InputLabelProps={{ shrink: true }}
                                                className={classes.textField}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'EmailAddress'}
                                                disabled={this.state.buzy || this.state.BlockChangeAddress}
                                                label={t('selfcare:label.email')}
                                                value={this.state.EmailAddress}
                                                onChange={this.handleChange('EmailAddress')}
                                                id="EmailAddress"
                                                className={classes.textField}
                                                inputProps={{ maxLength: 50 }}
                                                type='email'
                                                helperText={this.state.ErrorField === 'EmailAddress' && this.state.ErrorText}
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={(el) => { this.EmailAddress = el; }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} style={{ padding: '10px' }}>
                                            {this.state.IsNorway &&
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={this.state.IsUserAddressPrimary}
                                                            onChange={(e) => { this.setState({ IsUserAddressPrimary: e.target.checked }); }}
                                                            disabled={this.state.buzy || this.state.BlockChangeAddress}
                                                        />
                                                    }
                                                    label={t('selfcare:label.transferuserinfodirectoryservices')}
                                                    labelPlacement="end"
                                                />}
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={this.state.AllowEmailPassword}
                                                        onChange={(e) => { this.setState({ AllowEmailPassword: e.target.checked }); }}
                                                        disabled={this.state.buzy || this.state.BlockChangeAddress}
                                                    />
                                                }
                                                label={t('selfcare:label.emailcanreceivepassword')}
                                                labelPlacement="end"
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer direction="row">
                                        <GridItem>
                                            <div style={{ paddingTop: '20px' }}>
                                                <Button size="sm" onClick={() => { this.handleSave(); }} disabled={this.state.buzy || this.state.BlockChangeAddress} variant="contained" style={{ borderRadius: '19px', marginRight: '10px' }} color="rose">{t('selfcare:button.update')}</Button>
                                                <ButtonX id='cancel' size="small" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}>{t('selfcare:button.cancel')}</ButtonX>
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                    {this.state.buzy && <GridItem>
                                        <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                                    </GridItem>}
                                </GridItem>
                            </MuiThemeProvider>
                        </GridContainer>
                    </div>
            </div>
        );
    }
}
ChangeUserAddress.propTypes = {
};

export default compose(
    withStyles(styles),
    withTranslation(),
)(withAITracking(reactPlugin, ChangeUserAddress));

